export default __webpack_public_path__ + "static/media/error-banner.c1e70f7a.png";